import { FC, useContext } from 'react'
import './Actions.scss'
import { InternalContext } from '../contexts/InternalContext'
import { ActionsSelection } from './ActionsSelection'

export const Actions: FC = () => {
  const { internalSelection } = useContext(InternalContext)

  return (
    <div className="Actions">
      <div className="content">{internalSelection && <ActionsSelection range={internalSelection} />}</div>
    </div>
  )
}
